import { useState, useEffect } from 'react';

const FONTS = [
  'Georgia', 'Times New Roman', 'Arial', 'Helvetica', 'Courier New',
  'Impact', 'Comic Sans MS', 'Palatino', 'Garamond', 'Verdana',
  'Trebuchet MS', 'Arial Black', 'Lucida Console', 'Tahoma', 'Optima',
  'Baskerville', 'Didot', 'Gill Sans', 'Rockwell', 'Century Gothic',
  'Copperplate', 'American Typewriter', 'Marker Felt', 'Chalkboard',
  'Papyrus', 'fantasy', 'cursive', 'monospace', 'serif', 'sans-serif',
  'Futura', 'Bodoni MT', 'Caslon', 'Brush Script MT', 'Luminari',
  'Herculanum', 'Symbol', 'Zapf Dingbats', 'Snell Roundhand',
  'Geneva', 'Monaco', 'Menlo', 'Andale Mono',
];

function useFontCycle(offset = 0) {
  const [idx, setIdx] = useState(offset);
  useEffect(() => {
    const id = setInterval(() => setIdx(i => (i + 1) % FONTS.length), 5);
    return () => clearInterval(id);
  }, []);
  return FONTS[idx];
}

const PHOTOS = [
  'IMG_9428','IMG_9429','IMG_9430','IMG_9431','IMG_9432','IMG_9433',
  'IMG_9434','IMG_9435','IMG_9436','IMG_9437','IMG_9438','IMG_9439',
  'IMG_9440','IMG_9441','IMG_9442','IMG_9443','IMG_9444',
];

const POSTER_SIZES = [
  { label: 'Small  —  8" × 10"',  value: 'small',  price: 15 },
  { label: 'Medium  —  11" × 17"', value: 'medium', price: 25 },
  { label: 'Large  —  18" × 24"',  value: 'large',  price: 40 },
];

const RAW_SIZES = [
  { label: 'Small  —  8" × 10"',  value: 'small',  price: 20 },
  { label: 'Medium  —  11" × 17"', value: 'medium', price: 35 },
  { label: 'Large  —  18" × 24"',  value: 'large',  price: 55 },
];

const ORDER_EMAIL = 'latentspace.media@gmail.com';
const ORDER_SUBJECT = 'PRINT_ORDER_YOUENEMY';

function buildBody(product, sizeLabel, price) {
  return [
    `Hi,`,
    ``,
    `I'd like to reserve the following print:`,
    ``,
    `Product: ${product}`,
    `Size: ${sizeLabel}`,
    `Price: $${price} CAD`,
    ``,
    `---`,
    `My name: `,
    `My email: `,
    `Shipping address: `,
    ``,
    ``,
    `Notes: `,
  ].join('\n');
}

function buildLinks(product, sizeLabel, price) {
  const body = buildBody(product, sizeLabel, price);
  const mailto = `mailto:${ORDER_EMAIL}?subject=${encodeURIComponent(ORDER_SUBJECT)}&body=${encodeURIComponent(body)}`;
  const gmail  = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(ORDER_EMAIL)}&su=${encodeURIComponent(ORDER_SUBJECT)}&body=${encodeURIComponent(body)}`;
  return { mailto, gmail };
}

const btnStyle = {
  display: 'inline-block',
  background: 'none',
  border: '1px solid white',
  color: 'white',
  padding: '14px 24px',
  cursor: 'pointer',
  fontSize: '1rem',
  letterSpacing: '0.05em',
  marginTop: '10px',
  textDecoration: 'none',
  minWidth: '44px',
  minHeight: '44px',
};

const selectStyle = {
  background: '#000',
  border: '1px solid #555',
  color: 'white',
  padding: '6px 10px',
  fontSize: '0.85rem',
  cursor: 'pointer',
  marginTop: '10px',
  width: '100%',
  maxWidth: '260px',
  display: 'block',
  margin: '10px auto 0',
};

// deterministic pseudo-random from index so layout is stable on re-renders
function rand(seed) {
  const x = Math.sin(seed + 1) * 10000;
  return x - Math.floor(x);
}

function PhotoBackground() {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: -1, overflow: 'hidden' }}>
      {[...PHOTOS, ...PHOTOS, ...PHOTOS].reverse().map((name, i) => {
        const left  = rand(i * 4)     * 110 - 10;       // -10–100vw
        const top   = rand(i * 4 + 1) * 130 - 15;      // -15–115vh
        const width = 80 + rand(i * 4 + 2) * 400;      // 80–480px
        const angle = (rand(i * 4 + 3) - 0.5) * 36;    // ±18deg
        return (
          <img
            key={i}
            src={`/Collusion_Prints/photos/${name}.jpg`}
            alt=""
            style={{
              position: 'absolute',
              left: `${left}vw`,
              top: `${top}vh`,
              width: `${width}px`,
              height: 'auto',
              transform: `rotate(${angle}deg)`,
              display: 'block',
            }}
          />
        );
      })}
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.55)' }} />
    </div>
  );
}

function ZoomableImage({ src, alt }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        style={{ height: '420px', marginBottom: '14px', background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-in' }}
        onClick={() => setOpen(true)}
      >
        <img
          src={src}
          alt={alt}
          style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
        />
      </div>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'black',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'zoom-out'
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        </div>
      )}
    </>
  );
}

function ReserveButton({ label, links }) {
  const [choosing, setChoosing] = useState(false);

  return (
    <div style={{ marginTop: '10px' }}>
      {!choosing ? (
        <button onClick={() => setChoosing(true)} style={btnStyle}>{label}</button>
      ) : (
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <a href={links.gmail} target="_blank" rel="noreferrer" style={btnStyle}>gmail</a>
          <a href={links.mailto} style={btnStyle}>other</a>
          <button onClick={() => setChoosing(false)} style={{ background: 'none', border: 'none', color: '#666', cursor: 'pointer', fontSize: '1rem', padding: '14px', minWidth: '44px', minHeight: '44px' }}>✕</button>
        </div>
      )}
    </div>
  );
}

const cardStyle = {
  flex: '1 1 280px',
  maxWidth: '480px',
  background: '#000',
  padding: '14px',
};

export default function Collusion() {
  const [posterSize, setPosterSize] = useState(POSTER_SIZES[1]);
  const [rawSize,    setRawSize]    = useState(RAW_SIZES[1]);
  const font1 = useFontCycle(0);
  const font2 = useFontCycle(13);

  const posterLinks = buildLinks('Poster', posterSize.label, posterSize.price);
  const rawLinks    = buildLinks('Raw Print', rawSize.label, rawSize.price);

  return (
    <>
      <PhotoBackground />

      <div style={{ maxWidth: '1200px', width: '100%', margin: '0 auto', padding: '15px', color: 'white', textAlign: 'center' }}>

        <div style={{ height: '28px', overflow: 'hidden', marginBottom: '4px', marginTop: '6vh' }}>
          <p style={{ fontSize: '0.9rem', letterSpacing: '0.08em', fontFamily: font1, whiteSpace: 'nowrap' }}>You Enemy</p>
        </div>
        <div style={{ height: '60px', overflow: 'hidden', marginBottom: '30px' }}>
          <h1 style={{ fontSize: '2.5rem', fontFamily: font2, whiteSpace: 'nowrap' }}>Collusion</h1>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', marginBottom: '50px', justifyContent: 'center' }}>

          {/* poster */}
          <div style={cardStyle}>
            <ZoomableImage src="/Collusion_Prints/with.jpg" alt="Collusion – poster" />
            <p>Poster — ${posterSize.price}</p>
            <select
              style={selectStyle}
              value={posterSize.value}
              onChange={e => setPosterSize(POSTER_SIZES.find(s => s.value === e.target.value))}
            >
              {POSTER_SIZES.map(s => (
                <option key={s.value} value={s.value}>{s.label}  —  ${s.price}</option>
              ))}
            </select>
            <ReserveButton label="reserve your print!" links={posterLinks} />
          </div>

          {/* raw print */}
          <div style={cardStyle}>
            <ZoomableImage src="/Collusion_Prints/without.jpg" alt="Collusion – raw print" />
            <p>Raw Print — ${rawSize.price}</p>
            <select
              style={selectStyle}
              value={rawSize.value}
              onChange={e => setRawSize(RAW_SIZES.find(s => s.value === e.target.value))}
            >
              {RAW_SIZES.map(s => (
                <option key={s.value} value={s.value}>{s.label}  —  ${s.price}</option>
              ))}
            </select>
            <ReserveButton label='reserve your "raw" print!' links={rawLinks} />
          </div>

        </div>

        <br /><br /><br /><br />
      </div>
    </>
  );
}
